var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultipleAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.207 4.5C21.3946 4.68749 21.4999 4.9418 21.5 5.207V22.5C21.5 22.7652 21.3946 23.0196 21.2071 23.2071C21.0196 23.3946 20.7652 23.5 20.5 23.5H3.5C3.23478 23.5 2.98043 23.3946 2.79289 23.2071C2.60536 23.0196 2.5 22.7652 2.5 22.5V1.5C2.5 1.23478 2.60536 0.98043 2.79289 0.792893C2.98043 0.605357 3.23478 0.5 3.5 0.5H16.793C17.0582 0.500057 17.3125 0.605451 17.5 0.793L21.207 4.5Z",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.771L7.083 8.853C7.13428 8.90432 7.19612 8.94387 7.26421 8.9689C7.33231 8.99392 7.40504 9.00383 7.47735 8.99793C7.54966 8.99203 7.61983 8.97047 7.68297 8.93473C7.74611 8.899 7.80072 8.84995 7.843 8.791L10 5.771",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5H17.5",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.771L7.083 13.853C7.13428 13.9043 7.19612 13.9439 7.26421 13.9689C7.33231 13.9939 7.40504 14.0038 7.47735 13.9979C7.54966 13.992 7.61983 13.9705 7.68297 13.9347C7.74611 13.899 7.80072 13.85 7.843 13.791L10 10.771",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5H17.5",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.771L7.083 18.853C7.13428 18.9043 7.19612 18.9439 7.26421 18.9689C7.33231 18.9939 7.40504 19.0038 7.47735 18.9979C7.54966 18.992 7.61983 18.9705 7.68297 18.9347C7.74611 18.899 7.80072 18.85 7.843 18.791L10 15.771",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5H17.5",
    stroke: "#323130",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleAnswer);
export default __webpack_public_path__ + "static/media/MultipleAnswer.6278bfe6.svg";
export { ForwardRef as ReactComponent };